<template>
  <div class="map-fluid is-fullheight is-border-left is-border-right is-border-bottom is-padding-xsmall has-bg-white vadimmStockMapVue" id="lots-carte">
    <div class="loader-overlay is-radius-large"
          v-if="loading" id="map-loader-overlay">
      <spinner-round :loading="loading" v-if="loading"></spinner-round>
      <div class="columns is-vcentered is-min-height-full" v-if="!loading && (!programs || !programs.length)">
        <div class="column has-text-centered">
          <h1 class="title is-2 is-paddingless-bottom is-margin-bottom-small has-text-black">Aucun résultat</h1>
          <p class="is-paddingless-top is-margin-top-small has-text-black">Changez vos critères de filtrage</p>
        </div>
      </div>
    </div>
    <div class="vue-map-container" id="map" ref="mapbox">
      <button class="button" id="satellite-button" @click="toggleVisibility('mapbox-satellite')">
        <span class="icon"><i :class="{'fal fa-check': activeSatellite}"></i></span><span>Satellite</span>
      </button>
    </div>
    <program-card 
      v-if="selectedProgram"
      :stock="selectedProgram"
      :map-card="true"
      @update-card-content="displayPopup"
      class="card map-info map-info--large"
      id="card-content-original"
      style="display:none;"
    ></program-card>
  </div>
</template>

<script>
  import ProgramCard from './StockProgramCard'
  import mapboxgl from 'mapbox-gl'
  import { cleanQuery } from '@/utils'
  import { mapGetters } from 'vuex'
  import { debounce } from 'lodash'

  export default {
    name: 'StockMapMapbox',
    components: {ProgramCard},
    data () {
      return {
        activeSatellite: false,
        bounds: [[10.5, 51.2], [-4.55, 40.5]],
        mapboxToken: 'pk.eyJ1IjoidGltb3RoZWViYXQiLCJhIjoiY2p0OGh6eHdoMDhkNzN5bXI0cDVpMXhpbyJ9.QYQ0e-81WZO0oFsiSH6LzA',
       // mapboxToken: 'pk.eyJ1IjoiYW50b2luZW9rZ28iLCJhIjoiY2p0dTM5aWQ3MTBndzN5bW0zbzZjdGJ1NCJ9.RD6ube6dBLKHOkbvwNeB9g',
        mapboxStyle: 'mapbox://styles/timotheebat/cjye4bl2p3oy11cs29yu04fkw',
       // mapboxStyle: 'mapbox://styles/antoineokgo/cjulbo5jd0ktx1fmwqfq122wd',
        layersNotReady: true, // used to display overlay when the layers are loading on region mode change
        layersNational: ['countPoint', 'countLabel'],
        layersRegional: ['clusters', 'cluster-count', 'unclustered-point'],
      //  mapboxS: null,
        popup: null,
        popupAnchor: {},
       // programId: '',
        programLotCount: null,
        programsMap: {},
        programs: null,
        regionMode: true,
        selectedProgram: null, // id of the programe to generate the popup content from programCard component
        show: false,
        zoom: 5
      }
    },
    props: {
      sourceProgramsMap: {
        type: Object
      },
      filters: {
        type: Object
      },
      mapLoading: {
        type: Boolean
      },
      getProgramsLoading: {
        type: Boolean
      }
    },
    watch: {
      sourceProgramsMap (v) {
       // console.log('Watcher: sourceProgramsMap -1- =')
        if (v && !this.getProgramsLoading) {
          this.regionMode = this.sourceProgramsMap.regionMode // set the mode
          this.programs = this.sourceProgramsMap.data // get data in a variable
          if (this.regionMode) { // show national markers
            if (this.mapboxS.getSource('geojsonNational')) {
              for (let layer of this.layersNational) {
                this.mapboxS.setLayoutProperty(layer, 'visibility', 'visible')
              }
            } else {
              this.setupProgramMarkers(this.layersNational, 'geojsonNational')
            }
            for (let layer of this.layersRegional) {
              if (this.mapboxS.getLayer(layer)) this.mapboxS.removeLayer(layer)
            }
            if (this.mapboxS.getSource('geojsonRegional')) this.mapboxS.removeSource('geojsonRegional')
            if (this.popup !== null && this.popup.isOpen()) this.popup.remove()
            this.initMapBounds()
          }
        }
      },
      regionMode (v) { // hide either National or regional markers when changing region mode
       // console.log('Watcher: regionMode', v)
        if (!v) {
          if (this.mapboxS.getSource('geojsonNational')) { // hiding national markers
            for (let layer of this.layersNational) {
              this.mapboxS.setLayoutProperty(layer, 'visibility', 'none')
            }
          }
        } else { // hiding regional markers
          for (let layer of this.layersRegional) {
            if (this.mapboxS.getLayer(layer)) this.mapboxS.removeLayer(layer)
          }
          if (this.mapboxS.getSource('geojsonRegional')) this.mapboxS.removeSource('geojsonRegional')
        }
      },
      getProgramsLoading (v) {  // show regional markers
       // console.log('Watcher: getProgramsLoading', v)
        if (!v && this.sourceProgramsMap) { // set regional markers when click on a region cluster
          this.regionMode = this.sourceProgramsMap.regionMode
          this.programs = this.sourceProgramsMap.data
          if (this.mapboxS.hasImage('pulsing-dot')) {
            this.setupProgramMarkers(this.layersRegional, 'geojsonRegional')
          } else if (this.mapboxS) {
            this.addAnimatedImage()
            this.setupProgramMarkers(this.layersRegional, 'geojsonRegional')
          }
          if (this.popup !== null && this.popup.isOpen()) this.popup.remove()
          if (this.$route.query.bounds === undefined) this.initMapBounds() // if turning back from another page, set map to previous bounds
        }
      }
    },
    computed: {
      ...mapGetters(['isDistributeurMode']), // était déjà là, je ne sais pas à quoi ça sert
      loading () {
        return this.layersNotReady
      },
      lotListUrl () { // était déjà là, je ne sais pas à quoi ça sert
       // console.log('computed -> lotListUrl')
        let query = {
          nature: this.filters.nature,
          lot_type: this.filters.lot_type,
          date_livraison: this.filters.date_livraison,
          surface__gte: this.filters.surface__gte,
          surface__lte: this.filters.surface__lte,
          sale_price__gte: this.filters.sale_price__gte,
          sale_price__lte: this.filters.sale_price__lte,
          state: this.filters.state,
          bounds: this.bounds
        }
        Object.assign(query, this.$route.query)
        return {name: 'StockLots', query: query}
      },
      currentProgramUrl () { // était déjà là, je ne sais pas à quoi ça sert
        let url = this.lotListUrl
        url.query.program = this.program.program
        return url
      }
    },
    methods: {
      historySave: debounce(function () {
       // console.log('Method -> historySave')
        let query = {
          ...this.filters,
         // zoom: this.zoom,
          bounds: this.bounds
        }
        let queryString = cleanQuery(query)
        history.pushState(null, null, `#${this.$route.path}?${queryString}`)
      }, 500),
      regionFilter (v, e) {
        this.$emit('updateStateFilter', v)
      },
      initMapBounds () {
       // console.log('Method -> initMapBounds')
        if (!this.programs || (this.programs && !this.programs.length)) return
        let bounds = new mapboxgl.LngLatBounds()
        let index = 0
        for (let p of this.programs) {
          ++index
          if (this.regionMode) {
            if (p.center.longitude && p.center.latitude) bounds.extend(new mapboxgl.LngLat(p.center.longitude, p.center.latitude))
          } else {
            if (p.location.longitude && p.location.latitude) {
              if (p.location.latitude > 51 || p.location.latitude < 41.3 || p.location.longitude > 10 || p.location.longitude < -5) {
                console.log('Coordinates not corresponding to metropolitan France for p n°:', p.program, 'latitude:', p.location.latitude, 'longitude:', p.location.longitude)
              } else {
                bounds.extend(new mapboxgl.LngLat(p.location.longitude, p.location.latitude))
              }
            }
          }
          let maxZoom = 18
          if (this.programs.length <= 2) maxZoom = 8
          if (index === this.programs.length) this.mapboxS.fitBounds(bounds, {maxZoom: maxZoom, padding: {top: 130, bottom: 180, left: 150, right: 150}})
        }
      },
      setMap () {
       // console.log('  | Method -> setMap |')
        mapboxgl.accessToken = this.mapboxToken
        const mapConfig = {
          container: 'map',
          style: this.mapboxStyle,
          zoom: this.zoom,
          bounds: this.bounds,
          maxBounds: [{'lng': -9, 'lat': 40.5}, {'lng': 14.6, 'lat': 51.2}],
          maxZoom: 19,
          minZoom: 4,
          scrollZoom: false
        }
        if (!mapboxgl.supported()) {
          alert('Your browser does not support Mapbox GL')
        } else {
          this.mapboxS = new mapboxgl.Map(mapConfig)
          const navigationControl = new mapboxgl.NavigationControl({
            showCompass: false,
            showZoom: true
          })
          this.mapboxS.addControl(navigationControl, 'top-right')
          this.mapboxS.on('load', () => {
            this.addAnimatedImage()
            this.set3DLayer()
            this.popup = new mapboxgl.Popup({
              closeButton: false,
              className: 'stock-popup',
              closeOnClick: false,
              offset: 15,
              maxWidth: 'none'
            })
            if (this.$route.query.bounds !== undefined) this.mapboxS.zoomOut()
          // prevent web-gl context lost, official tip from: https://www.khronos.org/webgl/wiki/HandlingContextLost
            /* let canvas = document.getElementsByClassName('mapboxgl-canvas')
            if (canvas[0] !== undefined) {
              canvas[0].addEventListener('webglcontextlost', function (event) {
                event.preventDefault()
              }, false)
              canvas[0].addEventListener(.
                'webglcontextrestored', _this.mapProg.triggerRepaint(), false)
               // 'webglcontextrestored', setupWebGLStateAndResources, false)
            } */
          })
          let formerZoomIn
          if (this.mapboxS.loaded()) formerZoomIn = this.mapboxS.getZoom()
          this.mapboxS.on('zoomend', () => {
            let bounds = this.mapboxS.getBounds()
            this.bounds = [[bounds._sw.lng, bounds._sw.lat], [bounds._ne.lng, bounds._ne.lat]]
            this.historySave()
            let zoom = this.mapboxS.getZoom()
            if (zoom >= 16 && zoom <= 17 && zoom > formerZoomIn) {
              this.mapboxS.easeTo({duration: 1000, pitch: 45, zoom: 17})
            }
            if (zoom >= 16 && zoom <= 17 && zoom < formerZoomIn) {
              this.mapboxS.easeTo({pitch: 0, zoom: 16})
            }
            formerZoomIn = zoom
            if (zoom < 17 && this.mapboxS.getPitch() !== 0) this.mapboxS.easeTo({pitch: 0})
            if (zoom > 17 && this.mapboxS.getPitch() === 0) this.mapboxS.easeTo({pitch: 45})
          })
        }
      },
      set3DLayer () {
        this.mapboxS.addLayer({
          'id': '3D',
          'source': 'composite',
          'source-layer': 'building',
          'filter': ['==', 'extrude', 'true'],
          'type': 'fill-extrusion',
          'minzoom': 15,
          'layout': {
            'visibility': 'visible'
          },
          'paint': {
            'fill-extrusion-color': '#eeeeee',
            // use an 'interpolate' expression to add a smooth transition effect to the buildings as the user zooms in
            'fill-extrusion-height': [
              'interpolate', ['linear'], ['zoom'],
              15, 0,
              15.05, ['get', 'height']
            ],
            'fill-extrusion-base': [
              'interpolate', ['linear'], ['zoom'],
              15, 0,
              15.05, ['get', 'min_height']
            ],
            'fill-extrusion-opacity': 0.6
          }
        }, 'mapbox-satellite')
      },
      addAnimatedImage () {
       // console.log('Add animated image')
        let _this = this
        let size = 150
        let pulsingDot = {
          width: size,
          height: size,
          data: new Uint8Array(size * size * 4),
          onAdd: function () {
            let canvas = document.createElement('canvas')
            canvas.width = this.width
            canvas.height = this.height
            this.context = canvas.getContext('2d')
          },
          render: function () {
            let duration = 1000
            let t = (performance.now() % duration) / (duration * 1.5)
            let radius = size / 3 * 0.3
            let outerRadius = size / 2 * 0.7 * t + radius
            let context = this.context
            // draw outer circle
            context.clearRect(0, 0, this.width, this.height)
            context.beginPath()
            context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2)
            context.fillStyle = 'rgba(255, 200, 200,' + (1 - t) + ')'
            context.fill()
            // draw inner circle
            context.beginPath()
            context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2)
            context.fillStyle = 'rgba(255, 100, 100, 1)'
            context.lineWidth = 2 + 4 * (1 - t)
            context.fill()
            // update this image's data with data from the canvas
            this.data = context.getImageData(0, 0, this.width, this.height).data
            // keep the map repainting
            _this.mapboxS.triggerRepaint()
            // return `true` to let the map know that the image was updated
            return true
          }
        }
        if (!this.mapboxS.hasImage('pulsing-dot')) {
          this.mapboxS.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 })
        }
      },
      // addAnimatedImage () {
      //   console.log('add animated image')
      //   let _this = this
      //   let size = 200

      //   let pulsingDot = {
      //     width: size,
      //     height: size,
      //     data: new Uint8Array(size * size * 4),

      //     onAdd: function () {
      //       let canvas = document.createElement('canvas')
      //       canvas.width = this.width
      //       canvas.height = this.height
      //       this.context = canvas.getContext('2d')
      //     },

      //     render: function () {
      //       let duration = 1000
      //       let t = (performance.now() % duration) / (duration * 1.5)

      //       let radius = size / 3 * 0.3
      //       let outerRadius = size / 2 * 0.7 * t + radius
      //       let context = this.context

      //       // draw outer circle
      //       context.clearRect(0, 0, this.width, this.height)
      //       context.beginPath()
      //       context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2)
      //       context.fillStyle = 'rgba(255, 200, 200,' + (1 - t) + ')'
      //       context.fill()

      //       // draw inner circle
      //       context.beginPath()
      //       context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2)
      //       context.fillStyle = 'rgba(255, 100, 100, 1)'
      //      // context.strokeStyle = 'white'
      //       context.lineWidth = 2 + 4 * (1 - t)
      //       context.fill()
      //      // context.stroke()

      //       // update this image's data with data from the canvas
      //       this.data = context.getImageData(0, 0, this.width, this.height).data

      //       // keep the map repainting
      //       _this.map.triggerRepaint()

      //       // return `true` to let the map know that the image was updated
      //       return true
      //     }
      //   }
      //   this.map.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 })
      // },
      toggleVisibility (layer) {
        // console.log('Method -> toggleVisibility', layer)
        let visibility = this.mapboxS.getLayoutProperty(layer, 'visibility')
        if (visibility === 'visible') {
          this.mapboxS.setLayoutProperty(layer, 'visibility', 'none')
          if (layer === 'mapbox-satellite') this.activeSatellite = false
        } else {
          this.mapboxS.setLayoutProperty(layer, 'visibility', 'visible')
          if (layer === 'mapbox-satellite') this.activeSatellite = true
        }
      },
      async program2geojson () {
       // console.log('Method -> program2geojson')
        let locationsList = []
        let properties = {}
        let coordinates = []
        let features = this.programs.map(p => { // get features to integrate to the geojson
          if (p.count > 0) {      // if regionMode
            properties = {count: p.count, codes: p.codes}
            coordinates = [p.center.longitude, p.center.latitude]
          } else if (p.program) { // if not regionMode
            properties = {program: p.program}
            if (locationsList.findIndex((el) => { return el[0] === p.location.longitude && el[1] === p.location.latitude }) !== -1) { // check for duplicates location
              coordinates = [p.location.longitude + 0.00042, p.location.latitude - 0.0001] // move sligthly duplicate location to the right
            } else {
              coordinates = [p.location.longitude, p.location.latitude]
            }
            locationsList.push(coordinates)
          }
          return {
            'type': 'Feature',
            'properties': properties,
            'geometry': {
              'type': 'Point',
              'coordinates': coordinates
            }
          }
        })
        return features
      },
      addProgramSource (features, source, callback) {
       // console.log('Method -> addProgramSource', source)
        let isCluster = false
        if (!this.regionMode) isCluster = true
        this.mapboxS.addSource(source, {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: features
          },
          cluster: isCluster,
          clusterMaxZoom: 15 // Max zoom to cluster points on
        // clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
        })
        if (callback) callback()
      },
      addProgramSourceNlayers (layers, source, features) {
        for (let layer of layers) {
          if (this.mapboxS.getLayer(layer)) this.mapboxS.removeLayer(layer)
        }
        if (this.mapboxS.getSource(source)) this.mapboxS.removeSource(source)
        this.addProgramSource(features, source)
        this.addProgramLayers()
      },
      async setupProgramMarkers (layers, source) {
       // console.log('Method -> setupProgramMarkers', source)
        const progGeoPromise = this.program2geojson()
        let features
        try {
          features = await progGeoPromise
        } catch (e) {
          console.error('An error occured while waiting for progGeoPromise:', e)
        }
        if (this.mapboxS && features !== null) {
          if (this.mapboxS.isStyleLoaded()) {
            this.addProgramSourceNlayers(layers, source, features)
          } else {
            this.mapboxS.once('sourcedata', () => this.addProgramSourceNlayers(layers, source, features))
          }
        }
      },
      addProgramLayers () {
       // console.log('Method -> addProgramLayers')
       // if (!isNil(error)) console.error('Error passed to addProgramLayerNational', error)
        if (this.regionMode) {
          this.mapboxS.addLayer({
            id: 'countLabel',
            type: 'symbol',
            source: 'geojsonNational',
            layout: {
              'text-field': '{count}',
              'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
              'text-size': 12,
              'text-allow-overlap': true,
              'text-ignore-placement': true
            },
            paint: {
              'text-color': '#fff'
            }
          })
          this.mapboxS.addLayer({
            id: 'countPoint',
            type: 'symbol',
            source: 'geojsonNational',
            layout: {
              'icon-image': 'marqueur-map',
              'icon-size': 0.7,
              'symbol-z-order': 'source',
              'icon-allow-overlap': true,
              'icon-ignore-placement': true,
              'icon-padding': 0
            },
            paint: {
              'icon-opacity': 0.9
            }
          }, 'countLabel')
          this.changeMousePointer(this.layersNational) // change mouse pointer layout
          this.mapboxS.on('click', 'countPoint', (e) => { // inspect a cluster on click
            let features = this.mapboxS.queryRenderedFeatures(e.point, { layers: ['countPoint'] })
            if (features[0] !== undefined) {
              this.layersNotReady = true
              let regionCode = features[0].properties.codes.match(/\d\d/g)
              this.regionFilter(regionCode, this.$event)
              if (this.popup.isOpen()) this.popup.remove()
            }
          })
        } else {
          this.mapboxS.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'geojsonRegional',
            filter: ['has', 'point_count'],
            paint: {
              'circle-color': [ // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                'step', // with three steps to implement three types of circles:
                ['get', 'point_count'],
                '#51b2f7', //   * Blue, 17px circles when point count is less than 10
                10,
                '#ffc354', //   * Yellow, 19px circles when point count is between 10 and 50
                50,
                '#f87051' //   * Orange, 21px circles when point count is greater than or equal to 50
              ],
              'circle-radius': [
                'step',
                ['get', 'point_count'],
                17,
                10,
                19,
                50,
                21
              ],
              'circle-opacity': 0.9,
              'circle-stroke-color': [
                'step',
                ['get', 'point_count'],
                '#deedf7',
                10,
                '#fff6e5',
                50,
                '#f7e3de'
              ],
              'circle-stroke-width': [
                'step',
                ['get', 'point_count'],
                9,
                10,
                10,
                50,
                12
              ],
              'circle-stroke-opacity': 0.7
            }
          })
          this.mapboxS.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'geojsonRegional',
            filter: ['==', 'cluster', true],
            layout: {
              'text-field': '{point_count_abbreviated}',
              'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
              'text-size': 12,
              'text-allow-overlap': true,
              'text-ignore-placement': true
            }
          })
          this.mapboxS.addLayer({
            id: 'unclustered-point',
            type: 'symbol',
            source: 'geojsonRegional',
            filter: ['!', ['has', 'point_count']],
            layout: {
              'icon-image': 'pulsing-dot',
              'symbol-z-order': 'source',
              'icon-allow-overlap': true,
              'icon-ignore-placement': true,
              'icon-padding': 0,
              'icon-pitch-alignment': 'map'
            }
          })
          this.changeMousePointer(this.layersRegional)
          this.mapboxS.on('click', 'clusters', (e) => { // inspect a cluster on click
            let features = this.mapboxS.queryRenderedFeatures(e.point, { layers: ['clusters'] })
            let clusterId = features[0].properties.cluster_id
            this.mapboxS.getSource('geojsonRegional').getClusterExpansionZoom(clusterId, (err, zoom) => {
              if (err) return
              this.mapboxS.easeTo({ center: features[0].geometry.coordinates, zoom: zoom })
            })
          })
          this.mapboxS.on('click', 'unclustered-point', (e) => { // open a popup on click
            let features = this.mapboxS.queryRenderedFeatures(e.point, { layers: ['unclustered-point'] })
            this.popupAnchor = {lon: features[0].geometry.coordinates[0], lat: features[0].geometry.coordinates[1]}
           // this.programId = features[0].properties.program
            if (this.programs !== undefined) this.selectedProgram = this.programs.find(o => o.program === features[0].properties.program)
            if (this.popup !== null) this.displayPopup()
          })
        }
        this.layersNotReady = false
      },
      displayPopup () {
       // console.trace('Method -> displayPopup')
        let cardContent = window.document.getElementById('card-content-original')
        if (cardContent !== null) {
          if (this.popup.isOpen()) this.popup.remove()
          const zoomBeforePopup = this.mapboxS.getZoom()
          let duration = (5 + (20 - zoomBeforePopup)) * 100 // fix too fast zoom when far away
          if (zoomBeforePopup < 14) {
            this.mapboxS.flyTo({ center: this.popupAnchor, zoom: 14, duration: 1000 })
            this.mapboxS.once('zoomend', () => {
              this.mapboxS.flyTo({ center: this.popupAnchor, zoom: 17, duration: duration, pitch: 45 })
            })
          } else {
            this.mapboxS.flyTo({ center: this.popupAnchor, zoom: 17, duration: duration, pitch: 45 })
          }
          this.mapboxS.once('moveend', () => {
            this.popup.setLngLat(this.popupAnchor)
              .setHTML(`
              <div class="custom-stock-popup-close-button">
                <span class="icon is-small is-size-4"><i class="fal fa-times-circle"></i></span>
              </div>
              <div id="card-content" class="card map-info map-info--medium"> ${cardContent.innerHTML}</div>
              `)
              .addTo(this.mapboxS)
            let element = document.getElementsByClassName('custom-stock-popup-close-button')[0]
            element.addEventListener('click', () => {
              let zoom = this.mapboxS.getZoom()
              if (zoomBeforePopup < zoom) zoom = zoomBeforePopup
              if (zoomBeforePopup > 16) zoom = 15.5
              this.popup.remove()
              this.mapboxS.easeTo({center: this.popupAnchor, zoom: zoom, duration: 1000, pitch: 0})
            })
            element.addEventListener('mouseover', () => { document.body.style.cursor = 'pointer' })
            element.addEventListener('mouseleave', () => { document.body.style.cursor = '' })
          })
        }
      },
      changeMousePointer (layers) {
        for (let layer of layers) {
          this.mapboxS.on('mouseenter', layer, () => { this.mapboxS.getCanvas().style.cursor = 'pointer' })
          this.mapboxS.on('mouseleave', layer, () => { this.mapboxS.getCanvas().style.cursor = '' })
        }
      }
    },
    mounted () {
     // console.log('---- StockMap Mounted ----')
      this.setMap()
    },
    created () {
     // console.log('this.$route.query.bounds', this.$route.query.bounds)
      if (this.$route.query.bounds !== undefined) {
        let sw = this.$route.query.bounds[0].split(',')
        let ne = this.$route.query.bounds[1].split(',')
        this.bounds = [[parseFloat(sw[0]), parseFloat(sw[1])], [parseFloat(ne[0]), parseFloat(ne[1])]]
      }
    }
  }
</script>

<style lang="sass">
.vadimmStockMapVue
  #satellite-button
    position: absolute
    align-items: center
    top: 10px
    left: 10px
    height: 28px
    padding-left: 10px
    z-index: 10
    color: #4a4a4a
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif
  #satellite-button:hover, .mapboxgl-ctrl:hover
    background-color: #f7f7f7
  #satellite-button, .mapboxgl-ctrl-group
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2) !important
  .mapboxgl-popup .custom-stock-popup-close-button
    display: flex
    position: absolute
    top: 13px
    right: 13px
    z-index: 1
  .mapboxgl-popup-content
    border-radius: 6px
    background: rgba(255, 255, 255, 0.9)
    padding: 8px 8px 9px
  .mapboxgl-popup .fa-times-circle
    color: #666
  .mapboxgl-popup .fa-times-circle:hover
    color: #202020
  .mapboxgl-canvas
    z-index: -1
  #lots-carte.map-fluid
    .card.map-info
      border: 0
      &.map-info--large
        max-width: 100%
        width: 65vw
    .card-header-icon
      display: none
    .card-content
      padding-bottom: 0
</style>



// WEBPACK FOOTER //
// src/components/stock/StockMapMapbox.vue